<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              prop="name"
              label="名称">
              <a-input placeholder="请输入名称"  v-model="model.name"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              prop="code"
              label="模型CODE">
              <a-input placeholder="请输入模型CODE" v-model="model.code" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              prop="priority"
              label="优先级">
              <a-input-number v-model="model.priority" :min="0" :precision="0" style="width: 80%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'VoiceConfigModal',
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title:"操作",
        visible: false,
        model: {},
        confirmLoading: false,
        url: {
          add: "/project/voiceConfig/add",
          edit: "/project/voiceConfig/edit",
        },

        rules:{
          name:[baseRules.required],
          code:[baseRules.required],
          priority:[baseRules.required],
        },
      }
    },
    methods: {
      add () {
        this.edit({
          priority:0,
          projectId:'0'
        });
      },
      edit (record) {
        if(!record.projectId){
          record.projectId = this.projectId
        }
        this.model = Object.assign({}, record);
        console.log(this.model)
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        if(this.isView){
          that.close();
          return
        }
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style scoped>

</style>